import * as React from "react";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { TextBoxEditor } from "../../../../../react-core/Html/TextBoxEditor";
import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { NetworkType } from "../../../../../Wrap/Constants/Enums/Network/NetworkType";
import { FsaAuthorisationStatusMap, FsaAuthorisationStatusArray, errorMsg } from "../../Resource/Content";
import { AlphanumericWithSpecialCharacters, NoSpecial } from "../../../../../react-core/Html/Validation/RegExPatterns";
import { ValidatorContents } from "../../../../Dashboard/Common/ValidatorHelper";

interface IServiceProviderProps extends React.Props<ServiceProvider> {
    data: any;
    onChange: (changes) => void;
    onRef: (ref) => void;
    isReview: boolean;
}

interface IServiceProviderState {}

export class ServiceProvider extends FormComponent<IServiceProviderProps, IServiceProviderState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    render() {
        const { data } = this.props;
        return (
            <div className="row">
                <div className="col-xs-12 col-sm-7">
                    <h3>Network details</h3>
                    <TextBoxEditor
                        onChange={(v) => {
                            this.props.onChange({ NetworkName: v });
                        }}
                        value={data.NetworkName}
                        disabled={this.props.isReview}
                        maxLength={50}
                        regex={{ errorMessage: ValidatorContents.AlphaNumericWithSpecialCharacters, value: AlphanumericWithSpecialCharacters }}
                        label={"Network name*"}
                        required="Please enter network name"
                    />
                    <SelectEditor
                        options={[NetworkType.ServiceProvider]}
                        getText={(v) => "Service provider"}
                        label="Network type"
                        selected={NetworkType.ServiceProvider}
                        disabled={true}
                        onChange={(v) => {}}
                    />
                    <SelectEditor
                        disabled={this.props.isReview}
                        onChange={(v) => {
                            this.props.onChange({ FsaAuthorisationStatus: v });
                        }}
                        selected={data.FsaAuthorisationStatus}
                        label={"FCA/Trading status"}
                        getText={(v) => {
                            return FsaAuthorisationStatusMap[v];
                        }}
                        options={FsaAuthorisationStatusArray}
                        required="Please select FCA/Trading status"
                    />
                </div>
            </div>
        );
    }
}
